/** Keeps the page and browser overscroll background on the same theme. */
export function applyTheme(light: boolean): void {
	const root = document.documentElement
	root.classList.toggle('light', light)
	const background = getComputedStyle(root)
		.getPropertyValue('--color-background-500')
		.trim()
	document
		.querySelector<HTMLMetaElement>('meta[name="theme-color"]')
		?.setAttribute('content', background)
}
